export default "__VITE_ASSET__cGsEwJt___"